import React from 'react'
import {browserHistory, Route, Router} from 'react-router'
import Recherche from './Page/Recherche/'
import Modification from './Page/Modification/'
import Ajout from './Page/Ajout/'

export default _ =>
  <Router history={browserHistory}>
    <Route path="/menu" component={Recherche}/>
    <Route path="/menu/:id" component={Modification}/>
    <Route path="/menu/ajout" component={Ajout}/>
  </Router>



// WEBPACK FOOTER //
// ./app/App/Module/Menu/index.js